import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SearchField = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  max-width: 190px;
  margin-right: 20px;
  svg {
    position: absolute;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    margin-left: 2rem;
    padding-right: 1rem;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;
